<template lang="pug">
  .footprint-card
    tilt-card(:img="img" :copy="copy" @clicked="onClick")
</template>
<script>
import TiltCard from "@/components/home/TiltCard3"
import { mapGetters, mapMutations, mapState, mapActions } from "vuex"
import PopupSingle from "@/components/wedgits/PopupSingle"
const spaceImg = require("src/assets/space/monster-banner.png")
export default {
  name: "footprintCard",
  components: { TiltCard, PopupSingle },
  props: {},
  data() {
    return {
      img: spaceImg,
      copy: {
        cn: ""
      },
      notask: false
    }
  },
  watch: {
    appStatus() {
      this.$nextTick(() => {
        mySwiper && mySwiper.update()
        mySwiper && mySwiper.slideTo(0)
      })
    },
    user() {
      this.fetchFootprintTaskListAll()
    }
  },
  computed: {
    ...mapState("app", ["user", "appStatus", "ageWarning", "ageWarningShowed"])
  },
  methods: {
    ...mapMutations("app", [
      "setRouterBack",
      "setPending",
      "ageWarningConfirm",
      "resetWarning",
      "showAgeWarning"
    ]),
    ...mapActions("app", ["GetFootprintTaskListAll"]),
    fetchFootprintTaskListAll() {
      this.setPending(true)
      this.GetFootprintTaskListAll({ userId: this.user.id })
        .then(data => {
          if (!data.branchTask.length && !data.masterTask.length) {
            this.notask = true
          }

          this.setPending(false)
        })
        .catch(err => {
          console.log(err)
          this.setPending(false)
        })
    },
    onClick() {
      // this.$router.replace("/space/sticker")
      //   this.setRouterBack("/")
      if(this.appStatus==2){
        this.$router.replace("/space/sticker")
        this.setRouterBack("/")
      }
      if(this.appStatus != 2){
        this.resetWarning()
        this.showAgeWarning()
        return
      }

    }
  }
}
</script>

<style>
.footprintHtml {
  font-size: calc(100vw / 8.28) !important;
}
</style>

<style scoped lang="sass">
.footprint-card
  width: 100%
  height: 100%
</style>
